// Home.js
import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Api from '../axiosConfig';
import { AuthContext } from '../context/auth.context';
import '../style/home.css';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const Home = () => {
  const [allPosts, setAllPosts] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [likedPosts, setLikedPosts] = useState({});

  const { state, dispatch } = useContext(AuthContext);
  const router = useNavigate();

  // Fetch posts
  const getPosts = async () => {
    setLoading(true);
    try {
      const response = await Api.get('/post/all');
      if (response.data.success) {
        setAllPosts(response.data.posts);
        const userLikes = {};
        response.data.posts.forEach(post => {
          userLikes[post._id] = post.likes.includes(state?.user?._id);
        });
        setLikedPosts(userLikes);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch users
  const getUsers = async () => {
    try {
      const response = await Api.get('/auth/allusers');
      if (response.data.success) {
        setAllUsers(response.data.users);
      }
    } catch (error) {
      console.log(error);
    }
  };



  // Handle like
  const handleLike = async (postId) => {
    try {
      const response = await Api.post('/post/like', { postId, userId: state?.user?.userId });
      if (response.data.success) {
        setLikedPosts((prev) => ({
          ...prev,
          [postId]: !prev[postId]
        }));
        setAllPosts((prevPosts) => 
          prevPosts.map(post => 
            post._id === postId ? { ...post, likes: response.data.likes } : post
          )
        );
      }
    } catch (error) {
      toast.error('Failed to like post.');
    }
  };

  // Handle follow
  // Handle follow
 const handleFollow = async (followUserId) => {
    try {
      const response = await Api.post('/auth/follow', { userId: state.user.userId, followUserId });
      if (response.data.success) {
        setAllUsers(prevUsers =>
          prevUsers.map(user =>
            user._id === followUserId
              ? { ...user, isFollowing: true, followersCount: response.data.followersCount }
              : user
          )
        );
        toast.success('Followed successfully!');
      } else {
        toast.error('Failed to follow user.');
      }
    } catch (error) {
      toast.error('Error following user.');
    }
  };

  // Handle unfollow
  const handleUnfollow = async (followUserId) => {
    try {
      const response = await Api.post('/auth/unfollow', { userId: state.user.userId, followUserId });
      if (response.data.success) {
        setAllUsers(prevUsers =>
          prevUsers.map(user =>
            user._id === followUserId
              ? { ...user, isFollowing: false, followersCount: response.data.followersCount }
              : user
          )
        );
        toast.success('Unfollowed successfully!');
      } else {
        toast.error('Failed to unfollow user.');
      }
    } catch (error) {
      toast.error('Error unfollowing user.');
    }
  };


  useEffect(() => {
    getPosts();
    getUsers();
  }, []);

  const goToUserProfile = (userId) => {
    router(`/profile/${userId}`);
  };

  return (
    <div className="mainhomepage">
     
     <Navbar/>
      {loading ? (
        <div className="instagramlogo">Loading...</div>
      ) : (
        <div className="postMainDiv">
          {allPosts.map((post) => (
            <div key={post._id} className="postimage">
              <div className="postHeader">
                <img
                  className="profilePhotoSmall"
                  src={post.author.profilePicture || '/default-profile.png'}
                  alt={`${post.author.username}'s profile`}
                  onClick={() => router(`/profile/${post.author._id}`)}
                />
                <span className="username"
                  onClick={() => router(`/profile/${post.author._id}`)}>{post.author.username}</span>
              </div>
              <img className="postimagesize" src={post.image} alt={post.caption} />
              <div className="postFooter">
                <div className="likeSection" onClick={() => handleLike(post._id)}>
                  <i className={`fa-regular fa-heart ${likedPosts[post._id] ? 'liked' : 'not-liked'}`}></i>
                  <span className="likesCount">{post.likes.length} likes</span>
                </div>
                <div className="caption">
                  <p className="caption1">{post.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

<div className="SuggestDiv">
  <div className="postHeaderrightside" onClick={() => router(`/profile/${state?.user?.userId}`)}>
    <img
      className="profilePhotoSmall"
      src={state?.user?.profilePicture || '/default-profile.png'}
      alt={`${state?.user?.username}'s profile`}
    />
    <span className="usernameright">{state?.user?.username}</span>
  </div>
  <h1>Suggested for you</h1>
  {allUsers.length > 0 ? (
    <div className="suggestedUsersList">
      {allUsers.map((user) => (
        <div key={user._id} className="suggestedUser">
          <img
            className="profilePhotoSmall"
            src={user.profilePicture || '/default-profile.png'}
            alt={`${user.username}'s profile`}
            onClick={() => router(`/profile/${user._id}`)}
          />
          <span className="suggestedusername"
                  onClick={() => router(`/profile/${user._id}`)}>{user.username}</span>
          <button
            className={`followButton ${user.isFollowing ? 'following' : ''}`}
            onClick={() => handleFollow(user._id)}
          >
            {user.isFollowing ? 'Following' : 'Follow'}
          </button>
        </div>
      ))}
    </div>
  ) : (
    <p>No users found.</p>
  )}
</div>


      {/* Popup for search results */}

    </div>
  );
};

export default Home;
